<script setup lang="ts">
import type {
  VoixLinkFieldInterface,
  VoixMediaFieldInterface,
  VoixSelectFieldInterface,
  VoixTextFieldInterface,
  VoixWysiwygFieldInterface,
} from '@voix/types'
import { fill } from 'lodash'

defineProps<{
  fields: {
    image: VoixMediaFieldInterface
    title: VoixTextFieldInterface
    subtitle: VoixTextFieldInterface
    description: VoixWysiwygFieldInterface
    link: VoixLinkFieldInterface
    type: VoixSelectFieldInterface
  }
}>()

defineSlice({
  fields: {
    image: {
      type: 'media',
      label: 'Image',
      breakpoints: { default: { width: 1600, height: 800 } },
    },
    title: { type: 'text', label: 'Title', editorLabel: true },
    subtitle: { type: 'text', label: 'Sub-Title' },
    description: { type: 'wysiwyg', label: 'Description' },
    link: { type: 'link', label: 'Link' },
    type: {
      type: 'select',
      label: 'Type',
      options: { restaurant: 'Restaurant', bar: 'Bar' },
    },
  },
  name: {
    label: 'Seadust Restaurant List Block',
    group: 'Seadust',
    layouts: ['Seadust'],
  },
  templates: [
    {
      label: 'Seadust Restaurant List Block',
      fields: {
        description: {
          value:
            '<p>This personalized buffet is inspired by the world\u2019s top kitchens and offers a first-class experience with 11 interactive stations.<\/p>',
        },
        image: {
          value:
            'https:\/\/playa-cms-assets.s3.amazonaws.com\/media\/seadust\/gastronomy\/23\/seadust-cancun-food-gallery-architecture-1.jpg',
        },
        link: {
          value: {
            text: 'See More',
            target: '_self',
            relationship: null,
            href: '\/new-page',
          },
        },
        subtitle: { value: 'BUFFET' },
        title: { value: 'Food Gallery' },
        type: { value: 'restaurant' },
      },
    },
  ],
})

const mouseOver = ref(false)
</script>

<template>
  <figure class="relative bg-abs-black w-screen h-[300px] md:max-w-full md:h-[300px] xl:w-[380px] xl:h-[380px]">
    <VoixMedia :field="fields.image" class="h-full w-full object-cover opacity-[0.70]" />

    <div class="h-fit w-fit absolute top-12 left-12">
      <p class="font-subtitle text-3xl uppercase text-white">
        {{ fields.title.value }}
      </p>
      <p class="font-subtitle text-base uppercase text-white">
        {{ fields.subtitle.value }}
      </p>
    </div>

    <figcaption
      class="flex flex-col justify-center items-start space-y-4 absolute top-0 left-0 w-full h-full bg-color-accent opacity-0 hover:opacity-100 duration-500 p-8 z-20"
      @mouseover="mouseOver = true"
      @mouseleave="mouseOver = false"
    >
      <VoixWysiwyg
        :field="fields.description"
        class="relative font-copy text-white duration-500"
        :class="{
          'top-0': mouseOver,
          'top-8': !mouseOver,
        }"
      />
      <VoixLink
        :field="fields.link"
        class="link link-white animated-underline animated-underline-white relative duration-500"
        :class="{
          'top-2': mouseOver,
          '-top-2': !mouseOver,
        }"
      />
    </figcaption>
  </figure>
</template>
